<sonder-modal
  [sonderModalOpen]="modalOpen"
  (sonderModalClosed)="close()"
  class="sondermind-design-system not-accepting"
  data-test="not-enough-capacity-modal"
>
  <div class="not-accepting-wrapper" data-dd-privacy="allow">
    <div class="not-accepting-content">
      <h4
        class="not-accepting-header"
        aria-label="Stop receiving matches"
        data-test="stop-receiving-header"
      >
        Stop receiving new client matches?
      </h4>
      <p class="not-accepting-body">You mentioned you don't have capacity right now. Would you like to no longer receive new matches?</p>
    </div>
    <iris-button-container [alignment]="irisButtonContainerAlignments.END">
      <iris-button
        [buttonType]="irisButtonTypes.SECONDARY"
        (click)="closeModal()"
        aria-label="Close and keep new accepting clients"
        data-test="keep-accepting-clients"
      >
        Continue matching
      </iris-button>
      <iris-button
        (click)="stopMatching()"
        aria-label="Close and stop accepting new clients"
        data-test="stop-accepting-clients"
      >
        Stop matching
      </iris-button>
    </iris-button-container>
  </div>
</sonder-modal>
